// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AddressesGetDetailsData,
  AddressesGetDetailsErrors,
  AddressesGetDetailsResponses,
  AddressesSearchData,
  AddressesSearchErrors,
  AddressesSearchResponses,
  BaseRatesAddOrUpdateDataData,
  BaseRatesAddOrUpdateDataErrors,
  BaseRatesAddOrUpdateDataResponses,
  BaseRatesCheckBaseRateUsageData,
  BaseRatesCheckBaseRateUsageErrors,
  BaseRatesCheckBaseRateUsageResponses,
  BaseRatesCreateChangeRequestData,
  BaseRatesCreateChangeRequestErrors,
  BaseRatesCreateChangeRequestResponses,
  BaseRatesCreateDeleteCrData,
  BaseRatesCreateDeleteCrErrors,
  BaseRatesCreateDeleteCrResponses,
  BaseRatesDeleteDataData,
  BaseRatesDeleteDataResponses,
  BaseRatesGetAllBaseRatesData,
  BaseRatesGetAllBaseRatesErrors,
  BaseRatesGetAllBaseRatesResponses,
  BaseRatesGetDataData,
  BaseRatesGetDataErrors,
  BaseRatesGetDataResponses,
  BaseRatesGetResultData,
  BaseRatesGetResultErrors,
  BaseRatesGetResultResponses,
  BaseRatesValidateDeleteData,
  BaseRatesValidateDeleteErrors,
  BaseRatesValidateDeleteResponses,
  BdmCreateData,
  BdmCreateErrors,
  BdmCreateResponses,
  BdmDeleteData,
  BdmDeleteErrors,
  BdmDeleteResponses,
  BdmGetAllData,
  BdmGetAllErrors,
  BdmGetAllResponses,
  BdmGetByIdData,
  BdmGetByIdErrors,
  BdmGetByIdResponses,
  BdmReplaceData,
  BdmReplaceErrors,
  BdmReplaceResponses,
  BdmUpdateData,
  BdmUpdateErrors,
  BdmUpdateResponses,
  ChangeLogGetEntityChangeLogData,
  ChangeLogGetEntityChangeLogErrors,
  ChangeLogGetEntityChangeLogResponses,
  ChangeLogGetEntityChangesData,
  ChangeLogGetEntityChangesErrors,
  ChangeLogGetEntityChangesResponses,
  ChangeRequestApplyChangeRequestData,
  ChangeRequestApplyChangeRequestErrors,
  ChangeRequestApplyChangeRequestResponses,
  ChangeRequestApproveData,
  ChangeRequestApproveErrors,
  ChangeRequestApproveResponses,
  ChangeRequestCreateDraftData,
  ChangeRequestCreateDraftErrors,
  ChangeRequestCreateDraftResponses,
  ChangeRequestDeleteData,
  ChangeRequestDeleteErrors,
  ChangeRequestDeleteResponses,
  ChangeRequestGetData,
  ChangeRequestGetErrors,
  ChangeRequestGetLatestChangeRequestsData,
  ChangeRequestGetLatestChangeRequestsErrors,
  ChangeRequestGetLatestChangeRequestsResponses,
  ChangeRequestGetResponses,
  ChangeRequestGetValidationsData,
  ChangeRequestGetValidationsErrors,
  ChangeRequestGetValidationsResponses,
  ChangeRequestRejectData,
  ChangeRequestRejectErrors,
  ChangeRequestRejectResponses,
  ChangeRequestResubmissionRequiredData,
  ChangeRequestResubmissionRequiredErrors,
  ChangeRequestResubmissionRequiredResponses,
  ChangeRequestSetCloneTypeData,
  ChangeRequestSetCloneTypeErrors,
  ChangeRequestSetCloneTypeResponses,
  ConfigurationsGetConfigurationData,
  ConfigurationsGetConfigurationResponses,
  CreateExportTemplateData,
  CreateExportTemplateErrors,
  CreateExportTemplateResponses,
  CreateTableViewData,
  CreateTableViewErrors,
  CreateTableViewResponses,
  DeleteExportTemplateData,
  DeleteExportTemplateErrors,
  DeleteExportTemplateResponses,
  DeleteTableViewData,
  DeleteTableViewErrors,
  DeleteTableViewResponses,
  ErcProfilesAddOrUpdateDataData,
  ErcProfilesAddOrUpdateDataErrors,
  ErcProfilesAddOrUpdateDataResponses,
  ErcProfilesCheckUsageData,
  ErcProfilesCheckUsageErrors,
  ErcProfilesCheckUsageResponses,
  ErcProfilesCreateChangeRequestData,
  ErcProfilesCreateChangeRequestErrors,
  ErcProfilesCreateChangeRequestResponses,
  ErcProfilesCreateDeleteCrData,
  ErcProfilesCreateDeleteCrErrors,
  ErcProfilesCreateDeleteCrResponses,
  ErcProfilesDeleteDataData,
  ErcProfilesDeleteDataErrors,
  ErcProfilesDeleteDataResponses,
  ErcProfilesGetAllErcProfilesData,
  ErcProfilesGetAllErcProfilesErrors,
  ErcProfilesGetAllErcProfilesResponses,
  ErcProfilesGetDataData,
  ErcProfilesGetDataErrors,
  ErcProfilesGetDataResponses,
  ErcProfilesGetResultData,
  ErcProfilesGetResultErrors,
  ErcProfilesGetResultResponses,
  ErcProfilesValidateDeleteData,
  ErcProfilesValidateDeleteErrors,
  ErcProfilesValidateDeleteResponses,
  ExchangeRatesAddOrUpdateDataData,
  ExchangeRatesAddOrUpdateDataErrors,
  ExchangeRatesAddOrUpdateDataResponses,
  ExchangeRatesCreateChangeRequestData,
  ExchangeRatesCreateChangeRequestErrors,
  ExchangeRatesCreateChangeRequestResponses,
  ExchangeRatesCreateDeleteCrData,
  ExchangeRatesCreateDeleteCrErrors,
  ExchangeRatesCreateDeleteCrResponses,
  ExchangeRatesDeleteDataData,
  ExchangeRatesDeleteDataErrors,
  ExchangeRatesDeleteDataResponses,
  ExchangeRatesGetAllExchangeRatesData,
  ExchangeRatesGetAllExchangeRatesErrors,
  ExchangeRatesGetAllExchangeRatesResponses,
  ExchangeRatesGetDataData,
  ExchangeRatesGetDataErrors,
  ExchangeRatesGetDataResponses,
  ExchangeRatesGetResultData,
  ExchangeRatesGetResultErrors,
  ExchangeRatesGetResultResponses,
  ExchangeRatesValidateDeleteData,
  ExchangeRatesValidateDeleteErrors,
  ExchangeRatesValidateDeleteResponses,
  FeeDefinitionsAddOrUpdateDataData,
  FeeDefinitionsAddOrUpdateDataErrors,
  FeeDefinitionsAddOrUpdateDataResponses,
  FeeDefinitionsCheckUsageData,
  FeeDefinitionsCheckUsageErrors,
  FeeDefinitionsCheckUsageResponses,
  FeeDefinitionsCreateChangeRequestData,
  FeeDefinitionsCreateChangeRequestErrors,
  FeeDefinitionsCreateChangeRequestResponses,
  FeeDefinitionsCreateDeleteCrData,
  FeeDefinitionsCreateDeleteCrErrors,
  FeeDefinitionsCreateDeleteCrResponses,
  FeeDefinitionsDeleteDataData,
  FeeDefinitionsDeleteDataErrors,
  FeeDefinitionsDeleteDataResponses,
  FeeDefinitionsGetAllFeeDefinitionsData,
  FeeDefinitionsGetAllFeeDefinitionsErrors,
  FeeDefinitionsGetAllFeeDefinitionsResponses,
  FeeDefinitionsGetDataData,
  FeeDefinitionsGetDataErrors,
  FeeDefinitionsGetDataResponses,
  FeeDefinitionsGetResultData,
  FeeDefinitionsGetResultErrors,
  FeeDefinitionsGetResultResponses,
  FeeDefinitionsValidateDeleteData,
  FeeDefinitionsValidateDeleteErrors,
  FeeDefinitionsValidateDeleteResponses,
  FeeProfilesAddOrUpdateDataData,
  FeeProfilesAddOrUpdateDataErrors,
  FeeProfilesAddOrUpdateDataResponses,
  FeeProfilesCheckUsageData,
  FeeProfilesCheckUsageErrors,
  FeeProfilesCheckUsageResponses,
  FeeProfilesCreateChangeRequestData,
  FeeProfilesCreateChangeRequestErrors,
  FeeProfilesCreateChangeRequestResponses,
  FeeProfilesCreateDeleteCrData,
  FeeProfilesCreateDeleteCrErrors,
  FeeProfilesCreateDeleteCrResponses,
  FeeProfilesDeleteDataData,
  FeeProfilesDeleteDataErrors,
  FeeProfilesDeleteDataResponses,
  FeeProfilesGetAllFeeProfilesData,
  FeeProfilesGetAllFeeProfilesErrors,
  FeeProfilesGetAllFeeProfilesResponses,
  FeeProfilesGetDataData,
  FeeProfilesGetDataErrors,
  FeeProfilesGetDataResponses,
  FeeProfilesGetResultData,
  FeeProfilesGetResultErrors,
  FeeProfilesGetResultResponses,
  FeeProfilesValidateDeleteData,
  FeeProfilesValidateDeleteErrors,
  FeeProfilesValidateDeleteResponses,
  FirmIntermediariesGetFirmAdvisersData,
  FirmIntermediariesGetFirmAdvisersErrors,
  FirmIntermediariesGetFirmAdvisersResponses,
  FirmIntermediariesGetFirmAssistantsData,
  FirmIntermediariesGetFirmAssistantsErrors,
  FirmIntermediariesGetFirmAssistantsResponses,
  FirmProcFeeAssignmentsAddOrUpdateDataData,
  FirmProcFeeAssignmentsAddOrUpdateDataErrors,
  FirmProcFeeAssignmentsAddOrUpdateDataResponses,
  FirmProcFeeAssignmentsCreateChangeRequestData,
  FirmProcFeeAssignmentsCreateChangeRequestErrors,
  FirmProcFeeAssignmentsCreateChangeRequestResponses,
  FirmProcFeeAssignmentsCreateDeleteCrData,
  FirmProcFeeAssignmentsCreateDeleteCrErrors,
  FirmProcFeeAssignmentsCreateDeleteCrResponses,
  FirmProcFeeAssignmentsCreateFirmReorderChangeRequestData,
  FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors,
  FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses,
  FirmProcFeeAssignmentsDeleteDataData,
  FirmProcFeeAssignmentsDeleteDataErrors,
  FirmProcFeeAssignmentsDeleteDataResponses,
  FirmProcFeeAssignmentsGetAllFirmAssignmentsData,
  FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors,
  FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses,
  FirmProcFeeAssignmentsGetDataData,
  FirmProcFeeAssignmentsGetDataErrors,
  FirmProcFeeAssignmentsGetDataResponses,
  FirmProcFeeAssignmentsGetResultData,
  FirmProcFeeAssignmentsGetResultErrors,
  FirmProcFeeAssignmentsGetResultResponses,
  FirmProcFeeAssignmentsValidateDeleteData,
  FirmProcFeeAssignmentsValidateDeleteErrors,
  FirmProcFeeAssignmentsValidateDeleteResponses,
  FirmsAddOrUpdateDataData,
  FirmsAddOrUpdateDataErrors,
  FirmsAddOrUpdateDataResponses,
  FirmsCreateChangeRequestData,
  FirmsCreateChangeRequestErrors,
  FirmsCreateChangeRequestResponses,
  FirmsCreateDeleteCrData,
  FirmsCreateDeleteCrErrors,
  FirmsCreateDeleteCrResponses,
  FirmsDeleteDataData,
  FirmsDeleteDataErrors,
  FirmsDeleteDataResponses,
  FirmsGetAllFirmsData,
  FirmsGetAllFirmsErrors,
  FirmsGetAllFirmsResponses,
  FirmsGetDataData,
  FirmsGetDataErrors,
  FirmsGetDataResponses,
  FirmsGetFirmData,
  FirmsGetFirmErrors,
  FirmsGetFirmFcaDataData,
  FirmsGetFirmFcaDataErrors,
  FirmsGetFirmFcaDataResponses,
  FirmsGetFirmResponses,
  FirmsGetResultData,
  FirmsGetResultErrors,
  FirmsGetResultResponses,
  FirmsGetTradingAddressesData,
  FirmsGetTradingAddressesErrors,
  FirmsGetTradingAddressesResponses,
  FirmsValidateDeleteData,
  FirmsValidateDeleteErrors,
  FirmsValidateDeleteResponses,
  GetAllAdditionalFieldsData,
  GetAllAdditionalFieldsResponses,
  GetAllBrandsData,
  GetAllBrandsResponses,
  GetAllExportTemplatesData,
  GetAllExportTemplatesResponses,
  GetBaseRateData,
  GetBaseRateErrors,
  GetBaseRateResponses,
  GetTableViewsForADataTypeData,
  GetTableViewsForADataTypeResponses,
  ImportMatchingGetImportMatchingOfTypeData,
  ImportMatchingGetImportMatchingOfTypeResponses,
  ImportsAddImportRowsData,
  ImportsAddImportRowsErrors,
  ImportsAddImportRowsResponses,
  ImportSchemasGetAnImportSchemaData,
  ImportSchemasGetAnImportSchemaErrors,
  ImportSchemasGetAnImportSchemaResponses,
  ImportSchemasGetImportSchemasData,
  ImportSchemasGetImportSchemasErrors,
  ImportSchemasGetImportSchemasResponses,
  ImportsCreateImportData,
  ImportsCreateImportErrors,
  ImportsCreateImportResponses,
  ImportsDeleteImportData,
  ImportsDeleteImportErrors,
  ImportsDeleteImportResponses,
  ImportsDeleteImportRowsData,
  ImportsDeleteImportRowsErrors,
  ImportsDeleteImportRowsResponses,
  ImportsGetImportData,
  ImportsGetImportDataData,
  ImportsGetImportDataErrors,
  ImportsGetImportDataResponses,
  ImportsGetImportErrors,
  ImportsGetImportResponses,
  ImportsGetLatestImportsData,
  ImportsGetLatestImportsErrors,
  ImportsGetLatestImportsResponses,
  ImportsRecreateImportData,
  ImportsRecreateImportErrors,
  ImportsRecreateImportResponses,
  ImportsSubmitForReviewData,
  ImportsSubmitForReviewErrors,
  ImportsSubmitForReviewResponses,
  ImportsUpdateImportCellData,
  ImportsUpdateImportCellErrors,
  ImportsUpdateImportCellResponses,
  ImportsValidateImportData,
  ImportsValidateImportErrors,
  ImportsValidateImportResponses,
  InterestRatesAddOrUpdateDataData,
  InterestRatesAddOrUpdateDataErrors,
  InterestRatesAddOrUpdateDataResponses,
  InterestRatesCreateChangeRequestData,
  InterestRatesCreateChangeRequestErrors,
  InterestRatesCreateChangeRequestResponses,
  InterestRatesCreateIrDeleteCrData,
  InterestRatesCreateIrDeleteCrErrors,
  InterestRatesCreateIrDeleteCrResponses,
  InterestRatesDeleteDataData,
  InterestRatesDeleteDataErrors,
  InterestRatesDeleteDataResponses,
  InterestRatesGetDataData,
  InterestRatesGetDataErrors,
  InterestRatesGetDataResponses,
  InterestRatesGetResultData,
  InterestRatesGetResultErrors,
  InterestRatesGetResultResponses,
  InterestRatesValidateIrDeleteData,
  InterestRatesValidateIrDeleteErrors,
  InterestRatesValidateIrDeleteResponses,
  IntermediaryAddOrUpdateDataData,
  IntermediaryAddOrUpdateDataErrors,
  IntermediaryAddOrUpdateDataResponses,
  IntermediaryCreateChangeRequestData,
  IntermediaryCreateChangeRequestErrors,
  IntermediaryCreateChangeRequestResponses,
  IntermediaryCreateDeleteCrData,
  IntermediaryCreateDeleteCrErrors,
  IntermediaryCreateDeleteCrResponses,
  IntermediaryDeleteDataData,
  IntermediaryDeleteDataErrors,
  IntermediaryDeleteDataResponses,
  IntermediaryGetAllData,
  IntermediaryGetAllErrors,
  IntermediaryGetAllResponses,
  IntermediaryGetByIdData,
  IntermediaryGetByIdErrors,
  IntermediaryGetByIdResponses,
  IntermediaryGetDataData,
  IntermediaryGetDataErrors,
  IntermediaryGetDataResponses,
  IntermediaryGetIntermediaryFcaDataData,
  IntermediaryGetIntermediaryFcaDataErrors,
  IntermediaryGetIntermediaryFcaDataResponses,
  IntermediaryGetResultData,
  IntermediaryGetResultErrors,
  IntermediaryGetResultResponses,
  IntermediarySendInvitationEmailData,
  IntermediarySendInvitationEmailErrors,
  IntermediarySendInvitationEmailResponses,
  IntermediaryValidateDeleteData,
  IntermediaryValidateDeleteErrors,
  IntermediaryValidateDeleteResponses,
  LendersAddOrUpdateDataData,
  LendersAddOrUpdateDataErrors,
  LendersAddOrUpdateDataResponses,
  LendersCreateChangeRequestData,
  LendersCreateChangeRequestErrors,
  LendersCreateChangeRequestResponses,
  LendersGetDataData,
  LendersGetDataErrors,
  LendersGetDataResponses,
  LendersGetLenderData,
  LendersGetLenderErrors,
  LendersGetLenderResponses,
  LendersGetResultData,
  LendersGetResultErrors,
  LendersGetResultResponses,
  NotesCreateNoteData,
  NotesCreateNoteErrors,
  NotesCreateNoteResponses,
  NotesDeleteNoteData,
  NotesDeleteNoteErrors,
  NotesDeleteNoteResponses,
  NotesGetNotesData,
  NotesGetNotesErrors,
  NotesGetNotesResponses,
  NotesUpdateNoteData,
  NotesUpdateNoteErrors,
  NotesUpdateNoteResponses,
  OptionsGetAllOptionsForFieldsData,
  OptionsGetAllOptionsForFieldsErrors,
  OptionsGetAllOptionsForFieldsResponses,
  ProcurationFeeAssignmentsAddOrUpdateDataData,
  ProcurationFeeAssignmentsAddOrUpdateDataErrors,
  ProcurationFeeAssignmentsAddOrUpdateDataResponses,
  ProcurationFeeAssignmentsCreateChangeRequestData,
  ProcurationFeeAssignmentsCreateChangeRequestErrors,
  ProcurationFeeAssignmentsCreateChangeRequestResponses,
  ProcurationFeeAssignmentsCreateDeleteCrData,
  ProcurationFeeAssignmentsCreateDeleteCrErrors,
  ProcurationFeeAssignmentsCreateDeleteCrResponses,
  ProcurationFeeAssignmentsCreateReorderChangeRequestData,
  ProcurationFeeAssignmentsCreateReorderChangeRequestErrors,
  ProcurationFeeAssignmentsCreateReorderChangeRequestResponses,
  ProcurationFeeAssignmentsDeleteDataData,
  ProcurationFeeAssignmentsDeleteDataErrors,
  ProcurationFeeAssignmentsDeleteDataResponses,
  ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsData,
  ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors,
  ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses,
  ProcurationFeeAssignmentsGetDataData,
  ProcurationFeeAssignmentsGetDataErrors,
  ProcurationFeeAssignmentsGetDataResponses,
  ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsData,
  ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors,
  ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses,
  ProcurationFeeAssignmentsGetResultData,
  ProcurationFeeAssignmentsGetResultErrors,
  ProcurationFeeAssignmentsGetResultResponses,
  ProcurationFeeAssignmentsValidateDeleteData,
  ProcurationFeeAssignmentsValidateDeleteErrors,
  ProcurationFeeAssignmentsValidateDeleteResponses,
  ProcurationFeeCalculatorCalculateData,
  ProcurationFeeCalculatorCalculateErrors,
  ProcurationFeeCalculatorCalculateResponses,
  ProcurationFeeCalculatorCalculateV2Data,
  ProcurationFeeCalculatorCalculateV2Errors,
  ProcurationFeeCalculatorCalculateV2Responses,
  ProcurationFeeRulesAddOrUpdateDataData,
  ProcurationFeeRulesAddOrUpdateDataErrors,
  ProcurationFeeRulesAddOrUpdateDataResponses,
  ProcurationFeeRulesCheckUsageData,
  ProcurationFeeRulesCheckUsageErrors,
  ProcurationFeeRulesCheckUsageResponses,
  ProcurationFeeRulesCreateChangeRequestData,
  ProcurationFeeRulesCreateChangeRequestErrors,
  ProcurationFeeRulesCreateChangeRequestResponses,
  ProcurationFeeRulesCreateDeleteCrData,
  ProcurationFeeRulesCreateDeleteCrErrors,
  ProcurationFeeRulesCreateDeleteCrResponses,
  ProcurationFeeRulesDeleteDataData,
  ProcurationFeeRulesDeleteDataErrors,
  ProcurationFeeRulesDeleteDataResponses,
  ProcurationFeeRulesGetAllProcurationFeeRulesData,
  ProcurationFeeRulesGetAllProcurationFeeRulesErrors,
  ProcurationFeeRulesGetAllProcurationFeeRulesResponses,
  ProcurationFeeRulesGetDataData,
  ProcurationFeeRulesGetDataErrors,
  ProcurationFeeRulesGetDataResponses,
  ProcurationFeeRulesGetResultData,
  ProcurationFeeRulesGetResultErrors,
  ProcurationFeeRulesGetResultResponses,
  ProcurationFeeRulesValidateDeleteData,
  ProcurationFeeRulesValidateDeleteErrors,
  ProcurationFeeRulesValidateDeleteResponses,
  ProcurationFeesAddOrUpdateDataData,
  ProcurationFeesAddOrUpdateDataErrors,
  ProcurationFeesAddOrUpdateDataResponses,
  ProcurationFeesCheckUsageData,
  ProcurationFeesCheckUsageErrors,
  ProcurationFeesCheckUsageResponses,
  ProcurationFeesCreateChangeRequestData,
  ProcurationFeesCreateChangeRequestErrors,
  ProcurationFeesCreateChangeRequestResponses,
  ProcurationFeesCreateDeleteCrData,
  ProcurationFeesCreateDeleteCrErrors,
  ProcurationFeesCreateDeleteCrResponses,
  ProcurationFeesDeleteDataData,
  ProcurationFeesDeleteDataErrors,
  ProcurationFeesDeleteDataResponses,
  ProcurationFeesGetAllProcurationFeesData,
  ProcurationFeesGetAllProcurationFeesErrors,
  ProcurationFeesGetAllProcurationFeesResponses,
  ProcurationFeesGetDataData,
  ProcurationFeesGetDataErrors,
  ProcurationFeesGetDataResponses,
  ProcurationFeesGetResultData,
  ProcurationFeesGetResultErrors,
  ProcurationFeesGetResultResponses,
  ProcurationFeesValidateDeleteData,
  ProcurationFeesValidateDeleteErrors,
  ProcurationFeesValidateDeleteResponses,
  ProductChangesAddOrUpdateDataData,
  ProductChangesAddOrUpdateDataErrors,
  ProductChangesAddOrUpdateDataResponses,
  ProductChangesApplyColumnDeltaData,
  ProductChangesApplyColumnDeltaErrors,
  ProductChangesApplyColumnDeltaResponses,
  ProductChangesDeleteDataData,
  ProductChangesDeleteDataErrors,
  ProductChangesDeleteDataResponses,
  ProductChangesGetDataData,
  ProductChangesGetDataErrors,
  ProductChangesGetDataResponses,
  ProductChangesGetResultData,
  ProductChangesGetResultErrors,
  ProductChangesGetResultResponses,
  ProductChangesSubmitForReviewData,
  ProductChangesSubmitForReviewErrors,
  ProductChangesSubmitForReviewResponses,
  ProductExclusivitySetsAddOrUpdateDataData,
  ProductExclusivitySetsAddOrUpdateDataErrors,
  ProductExclusivitySetsAddOrUpdateDataResponses,
  ProductExclusivitySetsCheckUsageData,
  ProductExclusivitySetsCheckUsageErrors,
  ProductExclusivitySetsCheckUsageResponses,
  ProductExclusivitySetsCreateChangeRequestData,
  ProductExclusivitySetsCreateChangeRequestErrors,
  ProductExclusivitySetsCreateChangeRequestResponses,
  ProductExclusivitySetsCreateDeleteCrData,
  ProductExclusivitySetsCreateDeleteCrErrors,
  ProductExclusivitySetsCreateDeleteCrResponses,
  ProductExclusivitySetsDeleteDataData,
  ProductExclusivitySetsDeleteDataErrors,
  ProductExclusivitySetsDeleteDataResponses,
  ProductExclusivitySetsGetAllSetsData,
  ProductExclusivitySetsGetAllSetsErrors,
  ProductExclusivitySetsGetAllSetsResponses,
  ProductExclusivitySetsGetDataData,
  ProductExclusivitySetsGetDataErrors,
  ProductExclusivitySetsGetDataResponses,
  ProductExclusivitySetsGetResultData,
  ProductExclusivitySetsGetResultErrors,
  ProductExclusivitySetsGetResultResponses,
  ProductExclusivitySetsValidateDeleteData,
  ProductExclusivitySetsValidateDeleteErrors,
  ProductExclusivitySetsValidateDeleteResponses,
  ProductsGetAllProductsData,
  ProductsGetAllProductsErrors,
  ProductsGetAllProductsResponses,
  ProductsGetProductCodesData,
  ProductsGetProductCodesErrors,
  ProductsGetProductCodesResponses,
  RegionCreateData,
  RegionCreateErrors,
  RegionCreateResponses,
  RegionDeleteData,
  RegionDeleteErrors,
  RegionDeleteResponses,
  RegionGetAllData,
  RegionGetAllErrors,
  RegionGetAllResponses,
  RegionGetByIdData,
  RegionGetByIdErrors,
  RegionGetByIdResponses,
  RegionReplaceData,
  RegionReplaceErrors,
  RegionReplaceResponses,
  RegionUpdateData,
  RegionUpdateErrors,
  RegionUpdateResponses,
  StaffGetAllData,
  StaffGetAllResponses,
  StaffGetByIdData,
  StaffGetByIdErrors,
  StaffGetByIdResponses,
  TranslationsGetTranslationData,
  TranslationsGetTranslationErrors,
  TranslationsGetTranslationResponses,
  TranslationsGetTranslationsData,
  TranslationsGetTranslationsErrors,
  TranslationsGetTranslationsResponses,
  UpdateExportTemplateData,
  UpdateExportTemplateErrors,
  UpdateExportTemplateResponses,
  UpdateImportMatchingData,
  UpdateImportMatchingResponses,
  UpdateTableViewsData,
  UpdateTableViewsErrors,
  UpdateTableViewsResponses,
  UsersGetAllData,
  UsersGetAllResponses,
  UsersGetCurrentUserPermissionsData,
  UsersGetCurrentUserPermissionsResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<
  TData,
  ThrowOnError,
  TResponse
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const addressesSearch = <ThrowOnError extends boolean = true>(options?: Options<AddressesSearchData, ThrowOnError>) =>
  (options?.client ?? client).get<AddressesSearchResponses, AddressesSearchErrors, ThrowOnError>({ url: '/addresses/search', ...options });

export const addressesGetDetails = <ThrowOnError extends boolean = true>(options: Options<AddressesGetDetailsData, ThrowOnError>) =>
  (options.client ?? client).post<AddressesGetDetailsResponses, AddressesGetDetailsErrors, ThrowOnError>({
    url: '/addresses/details',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const baseRatesGetAllBaseRates = <ThrowOnError extends boolean = true>(
  options?: Options<BaseRatesGetAllBaseRatesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<BaseRatesGetAllBaseRatesResponses, BaseRatesGetAllBaseRatesErrors, ThrowOnError>({
    url: '/baserates',
    ...options,
  });

export const getBaseRate = <ThrowOnError extends boolean = true>(options: Options<GetBaseRateData, ThrowOnError>) =>
  (options.client ?? client).get<GetBaseRateResponses, GetBaseRateErrors, ThrowOnError>({ url: '/baserates/{baseRateCode}', ...options });

export const baseRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<BaseRatesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<BaseRatesCreateChangeRequestResponses, BaseRatesCreateChangeRequestErrors, ThrowOnError>({
    url: '/baserates/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const baseRatesCheckBaseRateUsage = <ThrowOnError extends boolean = true>(
  options: Options<BaseRatesCheckBaseRateUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<BaseRatesCheckBaseRateUsageResponses, BaseRatesCheckBaseRateUsageErrors, ThrowOnError>({
    url: '/baserates/{baseRateCode}/usage',
    ...options,
  });

export const baseRatesValidateDelete = <ThrowOnError extends boolean = true>(options: Options<BaseRatesValidateDeleteData, ThrowOnError>) =>
  (options.client ?? client).post<BaseRatesValidateDeleteResponses, BaseRatesValidateDeleteErrors, ThrowOnError>({
    url: '/baserates/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const baseRatesCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<BaseRatesCreateDeleteCrData, ThrowOnError>) =>
  (options.client ?? client).post<BaseRatesCreateDeleteCrResponses, BaseRatesCreateDeleteCrErrors, ThrowOnError>({
    url: '/baserates/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const baseRatesGetData = <ThrowOnError extends boolean = true>(options: Options<BaseRatesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<BaseRatesGetDataResponses, BaseRatesGetDataErrors, ThrowOnError>({
    url: '/baserates/{actionId}/data',
    ...options,
  });

export const baseRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<BaseRatesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<BaseRatesAddOrUpdateDataResponses, BaseRatesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/baserates/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const baseRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<BaseRatesDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<BaseRatesDeleteDataResponses, unknown, ThrowOnError>({
    url: '/baserates/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const baseRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<BaseRatesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<BaseRatesGetResultResponses, BaseRatesGetResultErrors, ThrowOnError>({
    url: '/baserates/{actionId}/result',
    ...options,
  });

export const bdmGetAll = <ThrowOnError extends boolean = true>(options?: Options<BdmGetAllData, ThrowOnError>) =>
  (options?.client ?? client).get<BdmGetAllResponses, BdmGetAllErrors, ThrowOnError>({ url: '/bdms', ...options });

export const bdmCreate = <ThrowOnError extends boolean = true>(options: Options<BdmCreateData, ThrowOnError>) =>
  (options.client ?? client).post<BdmCreateResponses, BdmCreateErrors, ThrowOnError>({
    url: '/bdms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const bdmDelete = <ThrowOnError extends boolean = true>(options: Options<BdmDeleteData, ThrowOnError>) =>
  (options.client ?? client).delete<BdmDeleteResponses, BdmDeleteErrors, ThrowOnError>({ url: '/bdms/{id}', ...options });

export const bdmGetById = <ThrowOnError extends boolean = true>(options: Options<BdmGetByIdData, ThrowOnError>) =>
  (options.client ?? client).get<BdmGetByIdResponses, BdmGetByIdErrors, ThrowOnError>({ url: '/bdms/{id}', ...options });

export const bdmUpdate = <ThrowOnError extends boolean = true>(options: Options<BdmUpdateData, ThrowOnError>) =>
  (options.client ?? client).put<BdmUpdateResponses, BdmUpdateErrors, ThrowOnError>({
    url: '/bdms/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const bdmReplace = <ThrowOnError extends boolean = true>(options: Options<BdmReplaceData, ThrowOnError>) =>
  (options.client ?? client).post<BdmReplaceResponses, BdmReplaceErrors, ThrowOnError>({
    url: '/bdms/{id}/replace',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeLogGetEntityChangeLog = <ThrowOnError extends boolean = true>(
  options?: Options<ChangeLogGetEntityChangeLogData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ChangeLogGetEntityChangeLogResponses, ChangeLogGetEntityChangeLogErrors, ThrowOnError>({
    url: '/change-log',
    ...options,
  });

export const changeLogGetEntityChanges = <ThrowOnError extends boolean = true>(
  options: Options<ChangeLogGetEntityChangesData, ThrowOnError>,
) =>
  (options.client ?? client).get<ChangeLogGetEntityChangesResponses, ChangeLogGetEntityChangesErrors, ThrowOnError>({
    url: '/change-log/{actionId}/changes',
    ...options,
  });

export const changeRequestCreateDraft = <ThrowOnError extends boolean = true>(
  options: Options<ChangeRequestCreateDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<ChangeRequestCreateDraftResponses, ChangeRequestCreateDraftErrors, ThrowOnError>({
    url: '/changeRequests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeRequestGet = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestGetData, ThrowOnError>) =>
  (options.client ?? client).get<ChangeRequestGetResponses, ChangeRequestGetErrors, ThrowOnError>({
    url: '/changeRequests/{actionId}',
    ...options,
  });

export const changeRequestGetLatestChangeRequests = <ThrowOnError extends boolean = true>(
  options?: Options<ChangeRequestGetLatestChangeRequestsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ChangeRequestGetLatestChangeRequestsResponses, ChangeRequestGetLatestChangeRequestsErrors, ThrowOnError>({
    url: '/changeRequests/list',
    ...options,
  });

export const changeRequestGetValidations = <ThrowOnError extends boolean = true>(
  options: Options<ChangeRequestGetValidationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ChangeRequestGetValidationsResponses, ChangeRequestGetValidationsErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/validations',
    ...options,
  });

export const changeRequestApprove = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestApproveData, ThrowOnError>) =>
  (options.client ?? client).post<ChangeRequestApproveResponses, ChangeRequestApproveErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/approve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeRequestReject = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestRejectData, ThrowOnError>) =>
  (options.client ?? client).post<ChangeRequestRejectResponses, ChangeRequestRejectErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/reject',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeRequestResubmissionRequired = <ThrowOnError extends boolean = true>(
  options: Options<ChangeRequestResubmissionRequiredData, ThrowOnError>,
) =>
  (options.client ?? client).post<ChangeRequestResubmissionRequiredResponses, ChangeRequestResubmissionRequiredErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/resubmission-required',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeRequestApplyChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ChangeRequestApplyChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<ChangeRequestApplyChangeRequestResponses, ChangeRequestApplyChangeRequestErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/apply',
    ...options,
  });

export const changeRequestSetCloneType = <ThrowOnError extends boolean = true>(
  options: Options<ChangeRequestSetCloneTypeData, ThrowOnError>,
) =>
  (options.client ?? client).put<ChangeRequestSetCloneTypeResponses, ChangeRequestSetCloneTypeErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/cloneType',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const changeRequestDelete = <ThrowOnError extends boolean = true>(options: Options<ChangeRequestDeleteData, ThrowOnError>) =>
  (options.client ?? client).post<ChangeRequestDeleteResponses, ChangeRequestDeleteErrors, ThrowOnError>({
    url: '/changeRequests/{changeRequestId}/delete',
    ...options,
  });

export const configurationsGetConfiguration = <ThrowOnError extends boolean = true>(
  options?: Options<ConfigurationsGetConfigurationData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ConfigurationsGetConfigurationResponses, unknown, ThrowOnError>({
    url: '/configuration/configuration',
    ...options,
  });

export const getAllBrands = <ThrowOnError extends boolean = true>(options?: Options<GetAllBrandsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetAllBrandsResponses, unknown, ThrowOnError>({ url: '/configuration/brands', ...options });

export const getAllAdditionalFields = <ThrowOnError extends boolean = true>(options?: Options<GetAllAdditionalFieldsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetAllAdditionalFieldsResponses, unknown, ThrowOnError>({
    url: '/configuration/additionalFields',
    ...options,
  });

export const ercProfilesGetAllErcProfiles = <ThrowOnError extends boolean = true>(
  options?: Options<ErcProfilesGetAllErcProfilesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ErcProfilesGetAllErcProfilesResponses, ErcProfilesGetAllErcProfilesErrors, ThrowOnError>({
    url: '/ercprofiles',
    ...options,
  });

export const ercProfilesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesCheckUsageData, ThrowOnError>) =>
  (options.client ?? client).get<ErcProfilesCheckUsageResponses, ErcProfilesCheckUsageErrors, ThrowOnError>({
    url: '/ercprofiles/{ercProfileId}/usage',
    ...options,
  });

export const ercProfilesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ErcProfilesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<ErcProfilesCreateChangeRequestResponses, ErcProfilesCreateChangeRequestErrors, ThrowOnError>({
    url: '/ercprofiles/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const ercProfilesValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ErcProfilesValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<ErcProfilesValidateDeleteResponses, ErcProfilesValidateDeleteErrors, ThrowOnError>({
    url: '/ercprofiles/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const ercProfilesCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ErcProfilesCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<ErcProfilesCreateDeleteCrResponses, ErcProfilesCreateDeleteCrErrors, ThrowOnError>({
    url: '/ercprofiles/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const ercProfilesGetData = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<ErcProfilesGetDataResponses, ErcProfilesGetDataErrors, ThrowOnError>({
    url: '/ercprofiles/{actionId}/data',
    ...options,
  });

export const ercProfilesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ErcProfilesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<ErcProfilesAddOrUpdateDataResponses, ErcProfilesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/ercprofiles/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const ercProfilesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<ErcProfilesDeleteDataResponses, ErcProfilesDeleteDataErrors, ThrowOnError>({
    url: '/ercprofiles/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const ercProfilesGetResult = <ThrowOnError extends boolean = true>(options: Options<ErcProfilesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<ErcProfilesGetResultResponses, ErcProfilesGetResultErrors, ThrowOnError>({
    url: '/ercprofiles/{actionId}/result',
    ...options,
  });

export const exchangeRatesGetAllExchangeRates = <ThrowOnError extends boolean = true>(
  options?: Options<ExchangeRatesGetAllExchangeRatesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ExchangeRatesGetAllExchangeRatesResponses, ExchangeRatesGetAllExchangeRatesErrors, ThrowOnError>({
    url: '/exchange-rates',
    ...options,
  });

export const exchangeRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ExchangeRatesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExchangeRatesCreateChangeRequestResponses, ExchangeRatesCreateChangeRequestErrors, ThrowOnError>({
    url: '/exchange-rates/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const exchangeRatesValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ExchangeRatesValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExchangeRatesValidateDeleteResponses, ExchangeRatesValidateDeleteErrors, ThrowOnError>({
    url: '/exchange-rates/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const exchangeRatesCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ExchangeRatesCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExchangeRatesCreateDeleteCrResponses, ExchangeRatesCreateDeleteCrErrors, ThrowOnError>({
    url: '/exchange-rates/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const exchangeRatesGetData = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<ExchangeRatesGetDataResponses, ExchangeRatesGetDataErrors, ThrowOnError>({
    url: '/exchange-rates/{actionId}/data',
    ...options,
  });

export const exchangeRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ExchangeRatesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExchangeRatesAddOrUpdateDataResponses, ExchangeRatesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/exchange-rates/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const exchangeRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<ExchangeRatesDeleteDataResponses, ExchangeRatesDeleteDataErrors, ThrowOnError>({
    url: '/exchange-rates/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const exchangeRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<ExchangeRatesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<ExchangeRatesGetResultResponses, ExchangeRatesGetResultErrors, ThrowOnError>({
    url: '/exchange-rates/{actionId}/result',
    ...options,
  });

export const getAllExportTemplates = <ThrowOnError extends boolean = true>(options?: Options<GetAllExportTemplatesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetAllExportTemplatesResponses, unknown, ThrowOnError>({ url: '/exportTemplates', ...options });

export const createExportTemplate = <ThrowOnError extends boolean = true>(options: Options<CreateExportTemplateData, ThrowOnError>) =>
  (options.client ?? client).post<CreateExportTemplateResponses, CreateExportTemplateErrors, ThrowOnError>({
    url: '/exportTemplates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const deleteExportTemplate = <ThrowOnError extends boolean = true>(options: Options<DeleteExportTemplateData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteExportTemplateResponses, DeleteExportTemplateErrors, ThrowOnError>({
    url: '/exportTemplates/{templateId}',
    ...options,
  });

export const updateExportTemplate = <ThrowOnError extends boolean = true>(options: Options<UpdateExportTemplateData, ThrowOnError>) =>
  (options.client ?? client).put<UpdateExportTemplateResponses, UpdateExportTemplateErrors, ThrowOnError>({
    url: '/exportTemplates/{templateId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeDefinitionsGetAllFeeDefinitions = <ThrowOnError extends boolean = true>(
  options?: Options<FeeDefinitionsGetAllFeeDefinitionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<FeeDefinitionsGetAllFeeDefinitionsResponses, FeeDefinitionsGetAllFeeDefinitionsErrors, ThrowOnError>({
    url: '/feedefinitions',
    ...options,
  });

export const feeDefinitionsCheckUsage = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsCheckUsageData, ThrowOnError>,
) =>
  (options.client ?? client).get<FeeDefinitionsCheckUsageResponses, FeeDefinitionsCheckUsageErrors, ThrowOnError>({
    url: '/feedefinitions/{feeId}/usage',
    ...options,
  });

export const feeDefinitionsCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeDefinitionsCreateChangeRequestResponses, FeeDefinitionsCreateChangeRequestErrors, ThrowOnError>({
    url: '/feedefinitions/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeDefinitionsValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeDefinitionsValidateDeleteResponses, FeeDefinitionsValidateDeleteErrors, ThrowOnError>({
    url: '/feedefinitions/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeDefinitionsCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeDefinitionsCreateDeleteCrResponses, FeeDefinitionsCreateDeleteCrErrors, ThrowOnError>({
    url: '/feedefinitions/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeDefinitionsGetData = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<FeeDefinitionsGetDataResponses, FeeDefinitionsGetDataErrors, ThrowOnError>({
    url: '/feedefinitions/{actionId}/data',
    ...options,
  });

export const feeDefinitionsAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeDefinitionsAddOrUpdateDataResponses, FeeDefinitionsAddOrUpdateDataErrors, ThrowOnError>({
    url: '/feedefinitions/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeDefinitionsDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<FeeDefinitionsDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<FeeDefinitionsDeleteDataResponses, FeeDefinitionsDeleteDataErrors, ThrowOnError>({
    url: '/feedefinitions/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const feeDefinitionsGetResult = <ThrowOnError extends boolean = true>(options: Options<FeeDefinitionsGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<FeeDefinitionsGetResultResponses, FeeDefinitionsGetResultErrors, ThrowOnError>({
    url: '/feedefinitions/{actionId}/result',
    ...options,
  });

export const feeProfilesGetAllFeeProfiles = <ThrowOnError extends boolean = true>(
  options?: Options<FeeProfilesGetAllFeeProfilesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<FeeProfilesGetAllFeeProfilesResponses, FeeProfilesGetAllFeeProfilesErrors, ThrowOnError>({
    url: '/feeprofiles',
    ...options,
  });

export const feeProfilesCheckUsage = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesCheckUsageData, ThrowOnError>) =>
  (options.client ?? client).get<FeeProfilesCheckUsageResponses, FeeProfilesCheckUsageErrors, ThrowOnError>({
    url: '/feeprofiles/{feeProfileId}/usage',
    ...options,
  });

export const feeProfilesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<FeeProfilesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeProfilesCreateChangeRequestResponses, FeeProfilesCreateChangeRequestErrors, ThrowOnError>({
    url: '/feeprofiles/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeProfilesValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<FeeProfilesValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeProfilesValidateDeleteResponses, FeeProfilesValidateDeleteErrors, ThrowOnError>({
    url: '/feeprofiles/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeProfilesCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<FeeProfilesCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeProfilesCreateDeleteCrResponses, FeeProfilesCreateDeleteCrErrors, ThrowOnError>({
    url: '/feeprofiles/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeProfilesGetData = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<FeeProfilesGetDataResponses, FeeProfilesGetDataErrors, ThrowOnError>({
    url: '/feeprofiles/{actionId}/data',
    ...options,
  });

export const feeProfilesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<FeeProfilesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<FeeProfilesAddOrUpdateDataResponses, FeeProfilesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/feeprofiles/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const feeProfilesDeleteData = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<FeeProfilesDeleteDataResponses, FeeProfilesDeleteDataErrors, ThrowOnError>({
    url: '/feeprofiles/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const feeProfilesGetResult = <ThrowOnError extends boolean = true>(options: Options<FeeProfilesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<FeeProfilesGetResultResponses, FeeProfilesGetResultErrors, ThrowOnError>({
    url: '/feeprofiles/{actionId}/result',
    ...options,
  });

export const firmIntermediariesGetFirmAdvisers = <ThrowOnError extends boolean = true>(
  options: Options<FirmIntermediariesGetFirmAdvisersData, ThrowOnError>,
) =>
  (options.client ?? client).get<FirmIntermediariesGetFirmAdvisersResponses, FirmIntermediariesGetFirmAdvisersErrors, ThrowOnError>({
    url: '/firm-intermediaries/{firmId}/advisers',
    ...options,
  });

export const firmIntermediariesGetFirmAssistants = <ThrowOnError extends boolean = true>(
  options: Options<FirmIntermediariesGetFirmAssistantsData, ThrowOnError>,
) =>
  (options.client ?? client).get<FirmIntermediariesGetFirmAssistantsResponses, FirmIntermediariesGetFirmAssistantsErrors, ThrowOnError>({
    url: '/firm-intermediaries/{firmId}/assistants',
    ...options,
  });

export const firmProcFeeAssignmentsGetAllFirmAssignments = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsGetAllFirmAssignmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses,
    FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors,
    ThrowOnError
  >({ url: '/firm-proc-fee-assignments/{firmId}', ...options });

export const firmProcFeeAssignmentsCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FirmProcFeeAssignmentsCreateChangeRequestResponses,
    FirmProcFeeAssignmentsCreateChangeRequestErrors,
    ThrowOnError
  >({
    url: '/firm-proc-fee-assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmProcFeeAssignmentsValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<FirmProcFeeAssignmentsValidateDeleteResponses, FirmProcFeeAssignmentsValidateDeleteErrors, ThrowOnError>({
    url: '/firm-proc-fee-assignments/firm/{firmId}/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmProcFeeAssignmentsCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<FirmProcFeeAssignmentsCreateDeleteCrResponses, FirmProcFeeAssignmentsCreateDeleteCrErrors, ThrowOnError>({
    url: '/firm-proc-fee-assignments/firm/{firmId}/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmProcFeeAssignmentsCreateFirmReorderChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsCreateFirmReorderChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses,
    FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors,
    ThrowOnError
  >({
    url: '/firm-proc-fee-assignments/firm/{firmId}/proc-fee-assignments/reorder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmProcFeeAssignmentsGetData = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsGetDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<FirmProcFeeAssignmentsGetDataResponses, FirmProcFeeAssignmentsGetDataErrors, ThrowOnError>({
    url: '/firm-proc-fee-assignments/{actionId}/data',
    ...options,
  });

export const firmProcFeeAssignmentsAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    FirmProcFeeAssignmentsAddOrUpdateDataResponses,
    FirmProcFeeAssignmentsAddOrUpdateDataErrors,
    ThrowOnError
  >({
    url: '/firm-proc-fee-assignments/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmProcFeeAssignmentsDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<FirmProcFeeAssignmentsDeleteDataResponses, FirmProcFeeAssignmentsDeleteDataErrors, ThrowOnError>({
    url: '/firm-proc-fee-assignments/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const firmProcFeeAssignmentsGetResult = <ThrowOnError extends boolean = true>(
  options: Options<FirmProcFeeAssignmentsGetResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<FirmProcFeeAssignmentsGetResultResponses, FirmProcFeeAssignmentsGetResultErrors, ThrowOnError>({
    url: '/firm-proc-fee-assignments/{actionId}/result',
    ...options,
  });

export const firmsGetAllFirms = <ThrowOnError extends boolean = true>(options?: Options<FirmsGetAllFirmsData, ThrowOnError>) =>
  (options?.client ?? client).get<FirmsGetAllFirmsResponses, FirmsGetAllFirmsErrors, ThrowOnError>({ url: '/firms', ...options });

export const firmsCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<FirmsCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<FirmsCreateChangeRequestResponses, FirmsCreateChangeRequestErrors, ThrowOnError>({
    url: '/firms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmsGetFirm = <ThrowOnError extends boolean = true>(options: Options<FirmsGetFirmData, ThrowOnError>) =>
  (options.client ?? client).get<FirmsGetFirmResponses, FirmsGetFirmErrors, ThrowOnError>({ url: '/firms/{firmId}', ...options });

export const firmsGetFirmFcaData = <ThrowOnError extends boolean = true>(options: Options<FirmsGetFirmFcaDataData, ThrowOnError>) =>
  (options.client ?? client).get<FirmsGetFirmFcaDataResponses, FirmsGetFirmFcaDataErrors, ThrowOnError>({
    url: '/firms/fca-data/{frn}',
    ...options,
  });

export const firmsGetTradingAddresses = <ThrowOnError extends boolean = true>(
  options: Options<FirmsGetTradingAddressesData, ThrowOnError>,
) =>
  (options.client ?? client).get<FirmsGetTradingAddressesResponses, FirmsGetTradingAddressesErrors, ThrowOnError>({
    url: '/firms/{firmId}/trading-addresses',
    ...options,
  });

export const firmsValidateDelete = <ThrowOnError extends boolean = true>(options: Options<FirmsValidateDeleteData, ThrowOnError>) =>
  (options.client ?? client).post<FirmsValidateDeleteResponses, FirmsValidateDeleteErrors, ThrowOnError>({
    url: '/firms/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmsCreateDeleteCr = <ThrowOnError extends boolean = true>(options: Options<FirmsCreateDeleteCrData, ThrowOnError>) =>
  (options.client ?? client).post<FirmsCreateDeleteCrResponses, FirmsCreateDeleteCrErrors, ThrowOnError>({
    url: '/firms/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmsGetData = <ThrowOnError extends boolean = true>(options: Options<FirmsGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<FirmsGetDataResponses, FirmsGetDataErrors, ThrowOnError>({ url: '/firms/{actionId}/data', ...options });

export const firmsAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<FirmsAddOrUpdateDataData, ThrowOnError>) =>
  (options.client ?? client).post<FirmsAddOrUpdateDataResponses, FirmsAddOrUpdateDataErrors, ThrowOnError>({
    url: '/firms/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const firmsDeleteData = <ThrowOnError extends boolean = true>(options: Options<FirmsDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<FirmsDeleteDataResponses, FirmsDeleteDataErrors, ThrowOnError>({
    url: '/firms/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const firmsGetResult = <ThrowOnError extends boolean = true>(options: Options<FirmsGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<FirmsGetResultResponses, FirmsGetResultErrors, ThrowOnError>({
    url: '/firms/{actionId}/result',
    ...options,
  });

export const updateImportMatching = <ThrowOnError extends boolean = true>(options: Options<UpdateImportMatchingData, ThrowOnError>) =>
  (options.client ?? client).put<UpdateImportMatchingResponses, unknown, ThrowOnError>({
    url: '/importMatching',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importMatchingGetImportMatchingOfType = <ThrowOnError extends boolean = true>(
  options: Options<ImportMatchingGetImportMatchingOfTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<ImportMatchingGetImportMatchingOfTypeResponses, unknown, ThrowOnError>({
    url: '/importMatching/{importEntityType}',
    ...options,
  });

export const importSchemasGetImportSchemas = <ThrowOnError extends boolean = true>(
  options?: Options<ImportSchemasGetImportSchemasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ImportSchemasGetImportSchemasResponses, ImportSchemasGetImportSchemasErrors, ThrowOnError>({
    url: '/import-schemas',
    ...options,
  });

export const importSchemasGetAnImportSchema = <ThrowOnError extends boolean = true>(
  options: Options<ImportSchemasGetAnImportSchemaData, ThrowOnError>,
) =>
  (options.client ?? client).get<ImportSchemasGetAnImportSchemaResponses, ImportSchemasGetAnImportSchemaErrors, ThrowOnError>({
    url: '/import-schemas/{importEntityType}',
    ...options,
  });

export const importsCreateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsCreateImportData, ThrowOnError>) =>
  (options.client ?? client).post<ImportsCreateImportResponses, ImportsCreateImportErrors, ThrowOnError>({
    url: '/imports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importsDeleteImport = <ThrowOnError extends boolean = true>(options: Options<ImportsDeleteImportData, ThrowOnError>) =>
  (options.client ?? client).delete<ImportsDeleteImportResponses, ImportsDeleteImportErrors, ThrowOnError>({
    url: '/imports/{importId}',
    ...options,
  });

export const importsGetImport = <ThrowOnError extends boolean = true>(options: Options<ImportsGetImportData, ThrowOnError>) =>
  (options.client ?? client).get<ImportsGetImportResponses, ImportsGetImportErrors, ThrowOnError>({
    url: '/imports/{importId}',
    ...options,
  });

export const importsRecreateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsRecreateImportData, ThrowOnError>) =>
  (options.client ?? client).put<ImportsRecreateImportResponses, ImportsRecreateImportErrors, ThrowOnError>({
    url: '/imports/{importId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importsGetLatestImports = <ThrowOnError extends boolean = true>(
  options?: Options<ImportsGetLatestImportsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ImportsGetLatestImportsResponses, ImportsGetLatestImportsErrors, ThrowOnError>({
    url: '/imports/list',
    ...options,
  });

export const importsGetImportData = <ThrowOnError extends boolean = true>(options: Options<ImportsGetImportDataData, ThrowOnError>) =>
  (options.client ?? client).get<ImportsGetImportDataResponses, ImportsGetImportDataErrors, ThrowOnError>({
    url: '/imports/{importId}/data',
    ...options,
  });

export const importsAddImportRows = <ThrowOnError extends boolean = true>(options: Options<ImportsAddImportRowsData, ThrowOnError>) =>
  (options.client ?? client).post<ImportsAddImportRowsResponses, ImportsAddImportRowsErrors, ThrowOnError>({
    url: '/imports/{importId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importsUpdateImportCell = <ThrowOnError extends boolean = true>(options: Options<ImportsUpdateImportCellData, ThrowOnError>) =>
  (options.client ?? client).put<ImportsUpdateImportCellResponses, ImportsUpdateImportCellErrors, ThrowOnError>({
    url: '/imports/{importId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const importsDeleteImportRows = <ThrowOnError extends boolean = true>(options: Options<ImportsDeleteImportRowsData, ThrowOnError>) =>
  (options.client ?? client).delete<ImportsDeleteImportRowsResponses, ImportsDeleteImportRowsErrors, ThrowOnError>({
    url: '/imports/{importId}/data/{rowNumbers}',
    ...options,
  });

export const importsValidateImport = <ThrowOnError extends boolean = true>(options: Options<ImportsValidateImportData, ThrowOnError>) =>
  (options.client ?? client).get<ImportsValidateImportResponses, ImportsValidateImportErrors, ThrowOnError>({
    url: '/imports/{importId}/errors',
    ...options,
  });

export const importsSubmitForReview = <ThrowOnError extends boolean = true>(options: Options<ImportsSubmitForReviewData, ThrowOnError>) =>
  (options.client ?? client).post<ImportsSubmitForReviewResponses, ImportsSubmitForReviewErrors, ThrowOnError>({
    url: '/imports/{importId}/submit-for-review',
    ...options,
  });

export const interestRatesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<InterestRatesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<InterestRatesCreateChangeRequestResponses, InterestRatesCreateChangeRequestErrors, ThrowOnError>({
    url: '/interest-rates/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const interestRatesValidateIrDelete = <ThrowOnError extends boolean = true>(
  options: Options<InterestRatesValidateIrDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<InterestRatesValidateIrDeleteResponses, InterestRatesValidateIrDeleteErrors, ThrowOnError>({
    url: '/interest-rates/interest-rates/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const interestRatesCreateIrDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<InterestRatesCreateIrDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<InterestRatesCreateIrDeleteCrResponses, InterestRatesCreateIrDeleteCrErrors, ThrowOnError>({
    url: '/interest-rates/interest-rates/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const interestRatesGetData = <ThrowOnError extends boolean = true>(options: Options<InterestRatesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<InterestRatesGetDataResponses, InterestRatesGetDataErrors, ThrowOnError>({
    url: '/interest-rates/{actionId}/data',
    ...options,
  });

export const interestRatesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<InterestRatesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<InterestRatesAddOrUpdateDataResponses, InterestRatesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/interest-rates/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const interestRatesDeleteData = <ThrowOnError extends boolean = true>(options: Options<InterestRatesDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<InterestRatesDeleteDataResponses, InterestRatesDeleteDataErrors, ThrowOnError>({
    url: '/interest-rates/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const interestRatesGetResult = <ThrowOnError extends boolean = true>(options: Options<InterestRatesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<InterestRatesGetResultResponses, InterestRatesGetResultErrors, ThrowOnError>({
    url: '/interest-rates/{actionId}/result',
    ...options,
  });

export const intermediaryGetAll = <ThrowOnError extends boolean = true>(options?: Options<IntermediaryGetAllData, ThrowOnError>) =>
  (options?.client ?? client).get<IntermediaryGetAllResponses, IntermediaryGetAllErrors, ThrowOnError>({
    url: '/intermediaries',
    ...options,
  });

export const intermediaryCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<IntermediaryCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<IntermediaryCreateChangeRequestResponses, IntermediaryCreateChangeRequestErrors, ThrowOnError>({
    url: '/intermediaries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const intermediaryGetById = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetByIdData, ThrowOnError>) =>
  (options.client ?? client).get<IntermediaryGetByIdResponses, IntermediaryGetByIdErrors, ThrowOnError>({
    url: '/intermediaries/{id}',
    ...options,
  });

export const intermediarySendInvitationEmail = <ThrowOnError extends boolean = true>(
  options: Options<IntermediarySendInvitationEmailData, ThrowOnError>,
) =>
  (options.client ?? client).put<IntermediarySendInvitationEmailResponses, IntermediarySendInvitationEmailErrors, ThrowOnError>({
    url: '/intermediaries/{id}/send-invite-email',
    ...options,
  });

export const intermediaryGetIntermediaryFcaData = <ThrowOnError extends boolean = true>(
  options: Options<IntermediaryGetIntermediaryFcaDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<IntermediaryGetIntermediaryFcaDataResponses, IntermediaryGetIntermediaryFcaDataErrors, ThrowOnError>({
    url: '/intermediaries/fca-data/{irn}',
    ...options,
  });

export const intermediaryValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<IntermediaryValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<IntermediaryValidateDeleteResponses, IntermediaryValidateDeleteErrors, ThrowOnError>({
    url: '/intermediaries/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const intermediaryCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<IntermediaryCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<IntermediaryCreateDeleteCrResponses, IntermediaryCreateDeleteCrErrors, ThrowOnError>({
    url: '/intermediaries/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const intermediaryGetData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<IntermediaryGetDataResponses, IntermediaryGetDataErrors, ThrowOnError>({
    url: '/intermediaries/{actionId}/data',
    ...options,
  });

export const intermediaryAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<IntermediaryAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<IntermediaryAddOrUpdateDataResponses, IntermediaryAddOrUpdateDataErrors, ThrowOnError>({
    url: '/intermediaries/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const intermediaryDeleteData = <ThrowOnError extends boolean = true>(options: Options<IntermediaryDeleteDataData, ThrowOnError>) =>
  (options.client ?? client).delete<IntermediaryDeleteDataResponses, IntermediaryDeleteDataErrors, ThrowOnError>({
    url: '/intermediaries/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const intermediaryGetResult = <ThrowOnError extends boolean = true>(options: Options<IntermediaryGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<IntermediaryGetResultResponses, IntermediaryGetResultErrors, ThrowOnError>({
    url: '/intermediaries/{actionId}/result',
    ...options,
  });

export const lendersGetLender = <ThrowOnError extends boolean = true>(options?: Options<LendersGetLenderData, ThrowOnError>) =>
  (options?.client ?? client).get<LendersGetLenderResponses, LendersGetLenderErrors, ThrowOnError>({ url: '/lenders', ...options });

export const lendersCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<LendersCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<LendersCreateChangeRequestResponses, LendersCreateChangeRequestErrors, ThrowOnError>({
    url: '/lenders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const lendersGetData = <ThrowOnError extends boolean = true>(options: Options<LendersGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<LendersGetDataResponses, LendersGetDataErrors, ThrowOnError>({
    url: '/lenders/{actionId}/data',
    ...options,
  });

export const lendersAddOrUpdateData = <ThrowOnError extends boolean = true>(options: Options<LendersAddOrUpdateDataData, ThrowOnError>) =>
  (options.client ?? client).post<LendersAddOrUpdateDataResponses, LendersAddOrUpdateDataErrors, ThrowOnError>({
    url: '/lenders/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const lendersGetResult = <ThrowOnError extends boolean = true>(options: Options<LendersGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<LendersGetResultResponses, LendersGetResultErrors, ThrowOnError>({
    url: '/lenders/{actionId}/result',
    ...options,
  });

export const notesGetNotes = <ThrowOnError extends boolean = true>(options?: Options<NotesGetNotesData, ThrowOnError>) =>
  (options?.client ?? client).get<NotesGetNotesResponses, NotesGetNotesErrors, ThrowOnError>({ url: '/notes', ...options });

export const notesCreateNote = <ThrowOnError extends boolean = true>(options: Options<NotesCreateNoteData, ThrowOnError>) =>
  (options.client ?? client).post<NotesCreateNoteResponses, NotesCreateNoteErrors, ThrowOnError>({
    url: '/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const notesDeleteNote = <ThrowOnError extends boolean = true>(options: Options<NotesDeleteNoteData, ThrowOnError>) =>
  (options.client ?? client).delete<NotesDeleteNoteResponses, NotesDeleteNoteErrors, ThrowOnError>({ url: '/notes/{noteId}', ...options });

export const notesUpdateNote = <ThrowOnError extends boolean = true>(options: Options<NotesUpdateNoteData, ThrowOnError>) =>
  (options.client ?? client).put<NotesUpdateNoteResponses, NotesUpdateNoteErrors, ThrowOnError>({
    url: '/notes/{noteId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const optionsGetAllOptionsForFields = <ThrowOnError extends boolean = true>(
  options?: Options<OptionsGetAllOptionsForFieldsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<OptionsGetAllOptionsForFieldsResponses, OptionsGetAllOptionsForFieldsErrors, ThrowOnError>({
    url: '/options',
    ...options,
  });

export const procurationFeeAssignmentsGetAllDefaultProcFeeAssignments = <ThrowOnError extends boolean = true>(
  options?: Options<ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses,
    ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors,
    ThrowOnError
  >({ url: '/procuration-fee-assignments/default', ...options });

export const procurationFeeAssignmentsGetFirmProcFeeAssignments = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses,
    ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors,
    ThrowOnError
  >({ url: '/procuration-fee-assignments/{firmId}', ...options });

export const procurationFeeAssignmentsCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeAssignmentsCreateChangeRequestResponses,
    ProcurationFeeAssignmentsCreateChangeRequestErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-assignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeAssignmentsValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeAssignmentsValidateDeleteResponses,
    ProcurationFeeAssignmentsValidateDeleteErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-assignments/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeAssignmentsCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeAssignmentsCreateDeleteCrResponses,
    ProcurationFeeAssignmentsCreateDeleteCrErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-assignments/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeAssignmentsCreateReorderChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsCreateReorderChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeAssignmentsCreateReorderChangeRequestResponses,
    ProcurationFeeAssignmentsCreateReorderChangeRequestErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-assignments/reorder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeAssignmentsGetData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsGetDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcurationFeeAssignmentsGetDataResponses, ProcurationFeeAssignmentsGetDataErrors, ThrowOnError>({
    url: '/procuration-fee-assignments/{actionId}/data',
    ...options,
  });

export const procurationFeeAssignmentsAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeAssignmentsAddOrUpdateDataResponses,
    ProcurationFeeAssignmentsAddOrUpdateDataErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-assignments/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeAssignmentsDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcurationFeeAssignmentsDeleteDataResponses, ProcurationFeeAssignmentsDeleteDataErrors, ThrowOnError>({
    url: '/procuration-fee-assignments/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const procurationFeeAssignmentsGetResult = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeAssignmentsGetResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcurationFeeAssignmentsGetResultResponses, ProcurationFeeAssignmentsGetResultErrors, ThrowOnError>({
    url: '/procuration-fee-assignments/{actionId}/result',
    ...options,
  });

export const procurationFeeCalculatorCalculate = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeCalculatorCalculateData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeCalculatorCalculateResponses, ProcurationFeeCalculatorCalculateErrors, ThrowOnError>({
    url: '/procuration-fee-calculator/calculate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeCalculatorCalculateV2 = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeCalculatorCalculateV2Data, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeCalculatorCalculateV2Responses, ProcurationFeeCalculatorCalculateV2Errors, ThrowOnError>({
    url: '/procuration-fee-calculator/calculateV2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesGetAllProcurationFeeRules = <ThrowOnError extends boolean = true>(
  options?: Options<ProcurationFeeRulesGetAllProcurationFeeRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ProcurationFeeRulesGetAllProcurationFeeRulesResponses,
    ProcurationFeeRulesGetAllProcurationFeeRulesErrors,
    ThrowOnError
  >({ url: '/procuration-fee-rules', ...options });

export const procurationFeeRulesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProcurationFeeRulesCreateChangeRequestResponses,
    ProcurationFeeRulesCreateChangeRequestErrors,
    ThrowOnError
  >({
    url: '/procuration-fee-rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesCheckUsage = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesCheckUsageData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeRulesCheckUsageResponses, ProcurationFeeRulesCheckUsageErrors, ThrowOnError>({
    url: '/procuration-fee-rules/usage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeRulesValidateDeleteResponses, ProcurationFeeRulesValidateDeleteErrors, ThrowOnError>({
    url: '/procuration-fee-rules/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeRulesCreateDeleteCrResponses, ProcurationFeeRulesCreateDeleteCrErrors, ThrowOnError>({
    url: '/procuration-fee-rules/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesGetData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesGetDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcurationFeeRulesGetDataResponses, ProcurationFeeRulesGetDataErrors, ThrowOnError>({
    url: '/procuration-fee-rules/{actionId}/data',
    ...options,
  });

export const procurationFeeRulesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeeRulesAddOrUpdateDataResponses, ProcurationFeeRulesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/procuration-fee-rules/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeeRulesDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcurationFeeRulesDeleteDataResponses, ProcurationFeeRulesDeleteDataErrors, ThrowOnError>({
    url: '/procuration-fee-rules/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const procurationFeeRulesGetResult = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeeRulesGetResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcurationFeeRulesGetResultResponses, ProcurationFeeRulesGetResultErrors, ThrowOnError>({
    url: '/procuration-fee-rules/{actionId}/result',
    ...options,
  });

export const procurationFeesGetAllProcurationFees = <ThrowOnError extends boolean = true>(
  options?: Options<ProcurationFeesGetAllProcurationFeesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ProcurationFeesGetAllProcurationFeesResponses, ProcurationFeesGetAllProcurationFeesErrors, ThrowOnError>({
    url: '/procuration-fees',
    ...options,
  });

export const procurationFeesCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeesCreateChangeRequestResponses, ProcurationFeesCreateChangeRequestErrors, ThrowOnError>({
    url: '/procuration-fees',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeesCheckUsage = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesCheckUsageData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeesCheckUsageResponses, ProcurationFeesCheckUsageErrors, ThrowOnError>({
    url: '/procuration-fees/usage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeesValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeesValidateDeleteResponses, ProcurationFeesValidateDeleteErrors, ThrowOnError>({
    url: '/procuration-fees/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeesCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeesCreateDeleteCrResponses, ProcurationFeesCreateDeleteCrErrors, ThrowOnError>({
    url: '/procuration-fees/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeesGetData = <ThrowOnError extends boolean = true>(options: Options<ProcurationFeesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<ProcurationFeesGetDataResponses, ProcurationFeesGetDataErrors, ThrowOnError>({
    url: '/procuration-fees/{actionId}/data',
    ...options,
  });

export const procurationFeesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcurationFeesAddOrUpdateDataResponses, ProcurationFeesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/procuration-fees/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const procurationFeesDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcurationFeesDeleteDataResponses, ProcurationFeesDeleteDataErrors, ThrowOnError>({
    url: '/procuration-fees/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const procurationFeesGetResult = <ThrowOnError extends boolean = true>(
  options: Options<ProcurationFeesGetResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcurationFeesGetResultResponses, ProcurationFeesGetResultErrors, ThrowOnError>({
    url: '/procuration-fees/{actionId}/result',
    ...options,
  });

export const productChangesGetData = <ThrowOnError extends boolean = true>(options: Options<ProductChangesGetDataData, ThrowOnError>) =>
  (options.client ?? client).get<ProductChangesGetDataResponses, ProductChangesGetDataErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/data',
    ...options,
  });

export const productChangesAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ProductChangesAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductChangesAddOrUpdateDataResponses, ProductChangesAddOrUpdateDataErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productChangesDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<ProductChangesDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProductChangesDeleteDataResponses, ProductChangesDeleteDataErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const productChangesSubmitForReview = <ThrowOnError extends boolean = true>(
  options: Options<ProductChangesSubmitForReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductChangesSubmitForReviewResponses, ProductChangesSubmitForReviewErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/submit-for-review',
    ...options,
  });

export const productChangesGetResult = <ThrowOnError extends boolean = true>(options: Options<ProductChangesGetResultData, ThrowOnError>) =>
  (options.client ?? client).get<ProductChangesGetResultResponses, ProductChangesGetResultErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/result',
    ...options,
  });

export const productChangesApplyColumnDelta = <ThrowOnError extends boolean = true>(
  options: Options<ProductChangesApplyColumnDeltaData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductChangesApplyColumnDeltaResponses, ProductChangesApplyColumnDeltaErrors, ThrowOnError>({
    url: '/products/changes/{actionId}/apply-column-delta',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsGetAllSets = <ThrowOnError extends boolean = true>(
  options?: Options<ProductExclusivitySetsGetAllSetsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ProductExclusivitySetsGetAllSetsResponses, ProductExclusivitySetsGetAllSetsErrors, ThrowOnError>({
    url: '/products/exclusivitySets',
    ...options,
  });

export const productExclusivitySetsCreateChangeRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsCreateChangeRequestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProductExclusivitySetsCreateChangeRequestResponses,
    ProductExclusivitySetsCreateChangeRequestErrors,
    ThrowOnError
  >({
    url: '/products/exclusivitySets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsCheckUsage = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsCheckUsageData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductExclusivitySetsCheckUsageResponses, ProductExclusivitySetsCheckUsageErrors, ThrowOnError>({
    url: '/products/exclusivitySets/usage',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsValidateDelete = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsValidateDeleteData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductExclusivitySetsValidateDeleteResponses, ProductExclusivitySetsValidateDeleteErrors, ThrowOnError>({
    url: '/products/exclusivitySets/validate-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsCreateDeleteCr = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsCreateDeleteCrData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProductExclusivitySetsCreateDeleteCrResponses, ProductExclusivitySetsCreateDeleteCrErrors, ThrowOnError>({
    url: '/products/exclusivitySets/delete-cr',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsGetData = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsGetDataData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProductExclusivitySetsGetDataResponses, ProductExclusivitySetsGetDataErrors, ThrowOnError>({
    url: '/products/exclusivitySets/{actionId}/data',
    ...options,
  });

export const productExclusivitySetsAddOrUpdateData = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsAddOrUpdateDataData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ProductExclusivitySetsAddOrUpdateDataResponses,
    ProductExclusivitySetsAddOrUpdateDataErrors,
    ThrowOnError
  >({
    url: '/products/exclusivitySets/{actionId}/data',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const productExclusivitySetsDeleteData = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsDeleteDataData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProductExclusivitySetsDeleteDataResponses, ProductExclusivitySetsDeleteDataErrors, ThrowOnError>({
    url: '/products/exclusivitySets/{actionId}/data/{rowNumbers}',
    ...options,
  });

export const productExclusivitySetsGetResult = <ThrowOnError extends boolean = true>(
  options: Options<ProductExclusivitySetsGetResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProductExclusivitySetsGetResultResponses, ProductExclusivitySetsGetResultErrors, ThrowOnError>({
    url: '/products/exclusivitySets/{actionId}/result',
    ...options,
  });

export const productsGetAllProducts = <ThrowOnError extends boolean = true>(options?: Options<ProductsGetAllProductsData, ThrowOnError>) =>
  (options?.client ?? client).get<ProductsGetAllProductsResponses, ProductsGetAllProductsErrors, ThrowOnError>({
    url: '/products',
    ...options,
  });

export const productsGetProductCodes = <ThrowOnError extends boolean = true>(
  options?: Options<ProductsGetProductCodesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ProductsGetProductCodesResponses, ProductsGetProductCodesErrors, ThrowOnError>({
    url: '/products/product-codes',
    ...options,
  });

export const regionGetAll = <ThrowOnError extends boolean = true>(options?: Options<RegionGetAllData, ThrowOnError>) =>
  (options?.client ?? client).get<RegionGetAllResponses, RegionGetAllErrors, ThrowOnError>({ url: '/regions', ...options });

export const regionCreate = <ThrowOnError extends boolean = true>(options: Options<RegionCreateData, ThrowOnError>) =>
  (options.client ?? client).post<RegionCreateResponses, RegionCreateErrors, ThrowOnError>({
    url: '/regions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const regionDelete = <ThrowOnError extends boolean = true>(options: Options<RegionDeleteData, ThrowOnError>) =>
  (options.client ?? client).delete<RegionDeleteResponses, RegionDeleteErrors, ThrowOnError>({ url: '/regions/{id}', ...options });

export const regionGetById = <ThrowOnError extends boolean = true>(options: Options<RegionGetByIdData, ThrowOnError>) =>
  (options.client ?? client).get<RegionGetByIdResponses, RegionGetByIdErrors, ThrowOnError>({ url: '/regions/{id}', ...options });

export const regionUpdate = <ThrowOnError extends boolean = true>(options: Options<RegionUpdateData, ThrowOnError>) =>
  (options.client ?? client).put<RegionUpdateResponses, RegionUpdateErrors, ThrowOnError>({
    url: '/regions/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const regionReplace = <ThrowOnError extends boolean = true>(options: Options<RegionReplaceData, ThrowOnError>) =>
  (options.client ?? client).post<RegionReplaceResponses, RegionReplaceErrors, ThrowOnError>({
    url: '/regions/{id}/replace',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const staffGetAll = <ThrowOnError extends boolean = true>(options?: Options<StaffGetAllData, ThrowOnError>) =>
  (options?.client ?? client).get<StaffGetAllResponses, unknown, ThrowOnError>({ url: '/staff', ...options });

export const staffGetById = <ThrowOnError extends boolean = true>(options: Options<StaffGetByIdData, ThrowOnError>) =>
  (options.client ?? client).get<StaffGetByIdResponses, StaffGetByIdErrors, ThrowOnError>({ url: '/staff/{id}', ...options });

export const createTableView = <ThrowOnError extends boolean = true>(options: Options<CreateTableViewData, ThrowOnError>) =>
  (options.client ?? client).post<CreateTableViewResponses, CreateTableViewErrors, ThrowOnError>({
    url: '/tableViews',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const getTableViewsForADataType = <ThrowOnError extends boolean = true>(
  options: Options<GetTableViewsForADataTypeData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTableViewsForADataTypeResponses, unknown, ThrowOnError>({
    url: '/tableViews/{entityType}',
    ...options,
  });

export const deleteTableView = <ThrowOnError extends boolean = true>(options: Options<DeleteTableViewData, ThrowOnError>) =>
  (options.client ?? client).delete<DeleteTableViewResponses, DeleteTableViewErrors, ThrowOnError>({
    url: '/tableViews/{viewId}',
    ...options,
  });

export const updateTableViews = <ThrowOnError extends boolean = true>(options: Options<UpdateTableViewsData, ThrowOnError>) =>
  (options.client ?? client).put<UpdateTableViewsResponses, UpdateTableViewsErrors, ThrowOnError>({
    url: '/tableViews/{viewId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const translationsGetTranslations = <ThrowOnError extends boolean = true>(
  options?: Options<TranslationsGetTranslationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<TranslationsGetTranslationsResponses, TranslationsGetTranslationsErrors, ThrowOnError>({
    url: '/translations',
    ...options,
  });

export const translationsGetTranslation = <ThrowOnError extends boolean = true>(
  options: Options<TranslationsGetTranslationData, ThrowOnError>,
) =>
  (options.client ?? client).get<TranslationsGetTranslationResponses, TranslationsGetTranslationErrors, ThrowOnError>({
    url: '/translations/{term}',
    ...options,
  });

export const usersGetAll = <ThrowOnError extends boolean = true>(options?: Options<UsersGetAllData, ThrowOnError>) =>
  (options?.client ?? client).get<UsersGetAllResponses, unknown, ThrowOnError>({ url: '/users', ...options });

export const usersGetCurrentUserPermissions = <ThrowOnError extends boolean = true>(
  options?: Options<UsersGetCurrentUserPermissionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersGetCurrentUserPermissionsResponses, unknown, ThrowOnError>({
    url: '/users/me/permissions',
    ...options,
  });
